import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Text } from '@chakra-ui/react';
import { Currency, LanguageEnum } from '@whitbread-eos/api';
import { formatCurrency, formatRatePrice } from '@whitbread-eos/utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function getFractionStyle(size) {
  switch (size) {
    case 'xxs':
      return {
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
        fontWeight: 'normal',
        marginLeft: '0.125rem'
      };
    case 'xs':
      return {
        fontSize: '0.675rem',
        lineHeight: '1.375rem',
        fontWeight: 'normal',
        marginLeft: '0.125rem'
      };
    case 's':
      return {
        fontSize: '0.75rem',
        lineHeight: '0.938rem',
        fontWeight: 'normal',
        marginLeft: '0.125rem'
      };
    case 'm':
      return {
        fontSize: '0.75rem',
        lineHeight: '1.0rem',
        fontWeight: 'normal',
        marginLeft: '0.125rem'
      };
    default:
      return {
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        fontWeight: 'normal',
        marginLeft: '0.125rem'
      };
  }
}
function getIntegerStyle(size) {
  switch (size) {
    case 'xs':
      return {
        fontSize: '1.25rem',
        lineHeight: '1.813rem',
        fontWeight: 'bold'
      };
    case 'xxs':
      return {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        fontWeight: 'bold'
      };
    case 's':
      return {
        fontSize: '1.25rem',
        lineHeight: '1.375rem',
        fontWeight: 'bold'
      };
    case 'm':
      return {
        fontSize: '1.625rem',
        lineHeight: '1.625rem',
        fontWeight: 'bold'
      };
    default:
      return {
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
        fontWeight: 'bold'
      };
  }
}
export default function PencePrice(_ref) {
  var price = _ref.price,
    currency = _ref.currency,
    language = _ref.language,
    size = _ref.size,
    lineThrough = _ref.lineThrough;
  var isPriceFormatDE = language === LanguageEnum.GERMAN && currency === Currency.EUR_NAME;
  var normalizedPrice = typeof price === 'number' ? formatRatePrice(price) : price;
  var _normalizedPrice$toSt = normalizedPrice.toString().split(/[.,]/),
    _normalizedPrice$toSt2 = _slicedToArray(_normalizedPrice$toSt, 2),
    integer = _normalizedPrice$toSt2[0],
    decimal = _normalizedPrice$toSt2[1];
  var currencySymbol = formatCurrency(currency || '');
  var separator = isPriceFormatDE ? ',' : '.';
  var formattedPrice = isPriceFormatDE ? "".concat(integer).concat(decimal ? separator + '' + decimal : '').concat(currencySymbol) : "".concat(currencySymbol).concat(integer).concat(decimal ? separator + '' + decimal : '');
  return _jsxs(Text, {
    "data-testid": "pence-price",
    as: "span",
    sx: pencePriceStyle,
    "aria-label": formattedPrice,
    "data-price": formattedPrice,
    textDecoration: lineThrough ? 'line-through' : undefined,
    children: [!isPriceFormatDE && _jsx(Text, {
      as: "span",
      "data-testid": "pence-price-leading-symbol",
      "aria-hidden": "true",
      sx: getIntegerStyle(size),
      children: currencySymbol
    }), _jsx(Text, {
      "data-testid": "pence-price-integer",
      as: "span",
      "aria-hidden": "true",
      sx: getIntegerStyle(size),
      children: integer
    }), decimal ? _jsxs(_Fragment, {
      children: [_jsx(Text, {
        as: "span",
        "data-testid": "pence-price-separator",
        sx: {
          visibility: 'hidden',
          width: '0',
          display: 'inline-block'
        },
        "aria-hidden": "true",
        children: separator
      }), _jsx(Text, {
        "data-testid": "pence-price-decimal",
        as: "span",
        sx: getFractionStyle(size),
        "aria-hidden": "true",
        children: decimal
      })]
    }) : null, isPriceFormatDE && _jsx(Text, {
      as: "span",
      "data-testid": "pence-price-trailing-symbol",
      "aria-hidden": "true",
      sx: getIntegerStyle(size),
      children: currencySymbol
    })]
  });
}
var pencePriceStyle = {
  display: 'inline-flex',
  alignItems: 'flex-start'
};